import { ReactNode, useState } from "react";
import { SxProps, Theme } from "@mui/material";

import Box from "@mui/material/Box";
import CardMedia from "@mui/material/CardMedia";

import {
  allowedFileTypes,
  getFileExtensionFromSignedUrl,
} from "../../../../../common/components/media/fileHelper";
import KeyFrameMessage from "../../../../../common/components/media/NoKeyFrameMessage";
import TableCellWithPhotoIconOnHover from "../../../../../common/components/table/TableCellWithPhotoIconOnHover";
import TableCellWithVideocamIconOnHover from "../../../../../common/components/table/TableCellWithVideocamIconOnHover";

interface RecentEventsHoverIconsProps {
  keyFrame: string;
  mediaOutput: string;
  onClick?: () => void;
  rootSx?: SxProps<Theme>;
  imgWidth?: number;
  imgHeight?: number;
  errorFallback?: ReactNode;
}

const RecentEventsHoverIcons = ({
  keyFrame,
  mediaOutput,
  onClick,
  rootSx,
  imgWidth = 120,
  imgHeight = 90,
  errorFallback: errorFallback = null,
}: RecentEventsHoverIconsProps) => {
  const [error, setError] = useState(!keyFrame && !mediaOutput);

  const fileExtension = getFileExtensionFromSignedUrl(mediaOutput);

  const isVideo = allowedFileTypes.videos.includes(fileExtension);

  const s3Key = keyFrame ?? mediaOutput;

  const fallback = errorFallback || (
    <KeyFrameMessage message="Please wait for the keyframe to retrieve" />
  );

  return (
    <Box
      sx={
        [
          {
            "& .hoverIcons": {
              display: "none",
              flex: 1,
              cursor: "pointer",
            },
            "&:hover .hoverIcons": {
              display: "flex",
              flex: 1,
              gap: "0.75em",
              position: "absolute",
              top: "33px",
              left: isVideo ? "32px" : "48px",
            },
            "& .videocamIcon": {
              zIndex: 1,
            },
          },
          rootSx,
        ].filter(Boolean) as SxProps<Theme>
      }
    >
      <Box className="hoverIcons">
        <TableCellWithPhotoIconOnHover
          className="photoIcon"
          onClick={onClick}
        />
        {isVideo && (
          <TableCellWithVideocamIconOnHover className="videocamIcon" />
        )}
      </Box>
      <Box onClick={onClick}>
        {error ? (
          fallback
        ) : (
          <CardMedia
            sx={{
              borderRadius: "4px",
            }}
            src={s3Key}
            width={imgWidth}
            height={imgHeight}
            component="img"
            onError={() => setError(true)}
          />
        )}
      </Box>
    </Box>
  );
};

export default RecentEventsHoverIcons;
